export default __webpack_public_path__ + "static/media/relojdearena.4b7f47f3.svg";